<div class="row m-0 d-flex w-100 py-1 px-3">
  <div *ngFor="let number of [1, 2, 3, 4, 5]" class="col d-flex justify-content-center col-picker-button">
    <app-satisfacao-picker-button
      [parentSelectedOption]="control?.value"
      [tooltip]="getSatisfacaoModel(number).descricao"
      [matIcon]="getMatIcon(number)"
      [grau]="number"
      (click)="writeValue(getSatisfacaoModel(number))"
    ></app-satisfacao-picker-button>
  </div>
</div>
